var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-2"},[_vm._v("Settings")]),_c('b-card',[_c('h5',[_vm._v("Manage Quickbooks Connection")]),_c('hr'),_c('b-button',{attrs:{"variant":"outline-secondary"}},[_vm._v(" Connect to Quickbooks ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }